export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-chord/src/array.js
// module id = 283
// module chunks = 0